import React, {Component} from 'react';

class ComputedValue extends Component {

    state = {
        value: ''
    }

    render() {

        return (
            <div>{this.props.name}: <strong>{this.props.value}</strong></div>
        );
    }

}

export default ComputedValue;



// WEBPACK FOOTER //
// ./src/components/ComputedValue.js